jQuery(document).ready(function($) {
    
    // Ensure we only initialize once
    if ($('.wp-block-query-filters').length > 0) {
        const $block = $('.wp-block-query-filters').first();
        const $filterInputs = $block.hasClass('query-filters-dropdown') ? 
                            $block.find('select') : 
                            $block.find('input[type="checkbox"]');
        
        // Initialize filters from URL parameters
        initializeFiltersFromUrl();
        
        if ($block.hasClass('query-filters-dropdown')) {
            $block.find('.filter-action-search').on('click', function(e) {
                e.preventDefault();
                console.log('Search clicked');
                updateUrl();
            });

            $block.find('.filter-action-clear').on('click', function(e) {
                e.preventDefault();
                console.log('Clear clicked');
                $block.find('select').val('');
                clearFilters();
            });
        } else {
            $filterInputs.on('change', function() {
                console.log('Checkbox changed');
                updateUrl();
            });
        }

        function updateUrl() {
            const activeFilters = {};
            let hasActiveFilters = false;

            if ($block.hasClass('query-filters-dropdown')) {
                $block.find('select').each(function() {
                    const taxonomy = $(this).data('taxonomy');
                    const term = $(this).val();
                    console.log('Dropdown value:', taxonomy, term);

                    if (term) {
                        activeFilters[taxonomy] = term;
                        hasActiveFilters = true;
                    }
                });
            } else {
                $block.find('[data-taxonomy]').each(function() {
                    const taxonomy = $(this).data('taxonomy');
                    const checkedTerms = [];
                    
                    $(this).find('input[type="checkbox"]:checked').each(function() {
                        checkedTerms.push($(this).val());
                    });
                    
                    if (checkedTerms.length > 0) {
                        activeFilters[taxonomy] = checkedTerms.join(',');
                        hasActiveFilters = true;
                    }
                });
            }

            // Build URL with filter parameters
            const url = new URL(window.location.href);
            
            // Clear existing filter parameters
            for (const key of url.searchParams.keys()) {
                if (key !== 'page_id') {  // Preserve page ID if present
                    url.searchParams.delete(key);
                }
            }
            
            // Add new filter parameters
            if (hasActiveFilters) {
                Object.entries(activeFilters).forEach(([taxonomy, terms]) => {
                    if (terms) {
                        url.searchParams.set(taxonomy, terms);
                    }
                });
            }

            // Update URL and reload page
            window.location.href = url.toString();
        }

        function clearFilters() {
            const url = new URL(window.location.href);
            
            // Clear all parameters except page_id
            for (const key of url.searchParams.keys()) {
                if (key !== 'page_id') {
                    url.searchParams.delete(key);
                }
            }
            
            window.location.href = url.toString();
        }

        function initializeFiltersFromUrl() {
            const url = new URL(window.location.href);
            
            if ($block.hasClass('query-filters-dropdown')) {
                $block.find('select').each(function() {
                    const taxonomy = $(this).data('taxonomy');
                    const value = url.searchParams.get(taxonomy);
                    if (value) {
                        $(this).val(value);
                    }
                });
            } else {
                $block.find('[data-taxonomy]').each(function() {
                    const taxonomy = $(this).data('taxonomy');
                    const terms = url.searchParams.get(taxonomy);
                    
                    if (terms) {
                        const termArray = terms.split(',');
                        $(this).find('input[type="checkbox"]').each(function() {
                            if (termArray.includes($(this).val())) {
                                $(this).prop('checked', true);
                            }
                        });
                    }
                });
            }
        }
    }
});
